import $api from 'app/providers/api/axios';

function parseFilenameFromContentDisposition(
  contentDisposition: string | undefined | null,
  fallbackFilename: string,
): string {
  if (!contentDisposition) return fallbackFilename;

  const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
  return filenameMatch?.[1] ?? fallbackFilename;
}

function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export async function downloadAuthenticatedFile(
  path: string,
  fallbackFilename: string,
): Promise<string> {
  const response = await $api.get<Blob>(path, { responseType: 'blob' });
  const filename = parseFilenameFromContentDisposition(
    response.headers['content-disposition'],
    fallbackFilename,
  );
  triggerBlobDownload(response.data, filename);
  return filename;
}
